/**
 * Account panel state management
 */
export default {
    namespaced: true,
    state: {
        current: {
            pane: 'overview',
            page: 'overview',
            subpage: 'index',
            data: {},
        },
        from: {
            pane: 'overview',
            page: 'overview',
            subpage: 'index'
        },
        revert: {
            pane: null,
            page: null,
            subpage: null
        },

        visible: false,
    },

    getters: {
        canRevert (state) {
            return (state.revert.pane !== null)
        },
        current (state) {
            return state.current
        },
        from (state) {
            return state.from
        },
        visible (state) {
            return state.visible
        }
    },
    mutations: {
        open (state) {
            state.current.pane = 'overview'
            state.current.page = 'overview'
            state.visible = true
        },
        show (state) {
            state.visible = true
        },
        hide (state, can_revert) {
            state.visible = false

            state.current.pane = 'overview'
            state.current.page = 'overview'
            state.current.subpage = 'index'
            state.current.data = {}
            
            state.from.pane = 'overview'
            state.from.page = 'overview'
            state.from.subpage = 'index'

            if (can_revert) {
                state.revert.pane = state.current.pane
                state.revert.page = state.current.page
                state.revert.subpage = state.current.subpage
            }
        },
        navigateTo (state, payload) {
            state.from.pane = state.current.pane
            state.from.page = state.current.page
            state.from.subpage = state.current.subpage
            state.current.pane = payload.pane
            state.current.page = payload.page
            state.current.subpage = (typeof payload.subpage === 'undefined') ? 'index' : payload.subpage
            state.current.data = (typeof payload.data === 'undefined') ? {} : payload.data

            state.revert.pane = null
            state.revert.page = null
            state.revert.subpage = null

            state.visible = true
        },
        navigateSubpage (state, which) {
            state.from.pane = state.current.pane
            state.from.page = state.current.page
            state.from.subpage = state.current.subpage
            state.current.subpage = which
        },
        navigateToReversion (state) {
            if (state.revert.pane) {
                state.current.pane = state.revert.pane
                state.current.page = state.revert.page
                state.current.subpage = state.revert.subpage
                state.visible = true
            }
        }
    },
    actions: {
        // Quick workaround for directly committed mutations that we now need to conditionally apply
        commitMutation ({ commit, dispatch, rootGetters }, payload) {
            if (!rootGetters['user/hasType']) {
                dispatch('modals/show', {
                    type: 'select-user-type',
                    maskCanDismiss: false,
                    headless: true
                }, {
                    root: true
                })
                  .then(() => {})
                  .catch(() => {})
                return
            }

            commit(payload.mutation, payload.data || null)
        }
    }
}
